export const CURRENCIES = [
  { code: "CAD", symbol: "CA$", label: "CAD — Canadian Dollar" },
  { code: "USD", symbol: "$", label: "USD — US Dollar" },
  { code: "GBP", symbol: "£", label: "GBP — British Pound" },
  { code: "EUR", symbol: "€", label: "EUR — Euro" },
  { code: "AUD", symbol: "A$", label: "AUD — Australian Dollar" },
];

export const symbolOf = (code) => (CURRENCIES.find((c) => c.code === code) || CURRENCIES[0]).symbol;

export const fmtMoney = (n, code = "CAD") =>
  `${symbolOf(code)}${(Number(n) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
